<template lang="pug">
 
  #error-msg
    split-text( :type="'words'" :classname="'error-copy'") Huh? Try Speaking up

</template>

<script>

import { mapState, mapMutations } from 'vuex' 
import TweenMax from 'gsap' 
import { map, clamp } from '@/helpers/MathUtils'
import SplitText from 'src/components/_utils/SplitText'

export default {

  name: 'error-msg',
  
  components: {
    SplitText
  },
  
  data() {
    return {
      messaging: ''
    }
  },
  
  computed: {
     ...mapState('question', [
      'STATES', 
      'state', 
      'result',
      'targetIndex',
      'GOALS'
    ])
  },
  
  mounted() {
    // let messaging = [
    //   'Huh? Speak up',
    //   'Wha? Check the volume on your voice box and start again' 
    // ]
 

  },
  
  beforeDestroy() {},
  
  methods: {

    hide() {
      TweenMax.to(this.$el, 1, {
        'autoAlpha': 0
      });
      TweenMax.staggerTo(this.list, 0, {
        y: 300 
      }, 0 );
    },  

    show() { 
      TweenMax.set(this.$el,   {
        'autoAlpha': 1 
      });

      this.list = this.$el.querySelectorAll('.error-copy');

      TweenMax.staggerTo(this.list, 1, {
        y: 0, 
        ease: 'Back.easeOut'
      }, 0.02);
    },

    updateTitle(){ }
  },
  
  watch: {

   'state'(val){
      if( 
        (val === this.STATES.COMPLETE) &&  (this.result.index === 9)
      ){ 
        this.show();
      } else {
        this.hide();
      }
    }
  }

}

</script>

<style lang="sass" >
@import "src/styles/common.sass"

#error-msg
  position : absolute;
  bottom: 4rem;
  width: calc(100% - 4rem);
  text-align: center;
  font-size: 1.6rem;
  visibilty: hidden;  
  padding-top: 1rem;

  .step
    > div
      margin-bottom: 0.5rem;
      display: inline-block !important;
      background: yellow;
      color: black;
      padding: 0.5rem;
      transform: translateY(300px)
      text-transform: uppercase;

  .msg
    margin: 0;
    position: relative;
    line-height: 1.6;
    color: black;
    background: #f8f4e2;
    padding: 2rem;

  p
    margin: 0;
    position: relative;
    line-height: 1.6; 
    color: black;
    padding: 0;


</style>